const asText = (value) => value || "";

export const makeCallEndInfo = (endTs, endedAtUtc) => ({
  endedAt: endTs,
  endedAtUtc,
  transferType: null,
  transferredCall: null,
  callTransferState: null,
});

export const getDraftValues = ({ notesRef, callResultRef, callResultGroupRef, subjectRef }) => ({
  notes: asText(notesRef?.current),
  callResult: asText(callResultRef?.current),
  callResultGroup: asText(callResultGroupRef?.current),
  subject: asText(subjectRef?.current),
});

export const getMetaWrapupValues = (meta) => ({
  notes: asText(meta?.notes),
  callResult: asText(meta?.callResult),
  callResultGroup: asText(meta?.callResultGroup),
  subject: asText(meta?.subject),
});

export const applyWrapupValuesToEndInfo = (endInfoObj, values) => ({
  ...endInfoObj,
  notes: asText(values?.notes),
  callResult: asText(values?.callResult),
  callResultGroup: asText(values?.callResultGroup),
  subject: asText(values?.subject),
});

export const getVisibleCallEntry = ({ callMap, excludedCallId, prefer = "non-wrapup-first" }) => {
  const entries = [...(callMap?.entries?.() || [])].filter(([key]) => key !== excludedCallId);
  if (entries.length === 0) {
    return null;
  }

  if (prefer === "last") {
    return entries[entries.length - 1] || null;
  }

  const nonWrapupEntry = entries.find(([, value]) => !value?.isWrapup);
  return nonWrapupEntry || entries[0] || null;
};

export const getWrapupSavePayload = ({ wrapupCall, isEditingThisWrapupCall, uiDraft }) => {
  if (isEditingThisWrapupCall) {
    return {
      notes: asText(uiDraft?.notes),
      callResult: asText(uiDraft?.callResult),
      callResultGroup: asText(uiDraft?.callResultGroup),
      subject: asText(uiDraft?.subject),
    };
  }

  return {
    notes: asText(wrapupCall?.notes),
    callResult: asText(wrapupCall?.callResult),
    callResultGroup: asText(wrapupCall?.callResultGroup),
    subject: asText(wrapupCall?.subject),
  };
};
